import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import BlogPost from "@/pages/blog/BlogPost";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/kakobuy-spreadsheet-polska",
    element: <BlogPost />,
  },
  {
    path: "/blog/kakobuy-spreadsheet-shoes",
    element: <BlogPost />,
  },
  {
    path: "/blog/kakobuy-spreadsheet-clothing",
    element: <BlogPost />,
  },
  {
    path: "/blog/kakobuy-yupoo",
    element: <BlogPost />,
  },
  {
    path: "/blog/kakobuy-shipping",
    element: <BlogPost />,
  },
  {
    path: "/blog/is-kakobuy-safe",
    element: <BlogPost />,
  },
  {
    path: "/blog/kakobuy-spreadsheet-sneakers",
    element: <BlogPost />,
  },
  {
    path: "/blog/kakobuy-spreadsheet-nike",
    element: <BlogPost />,
  },
  {
    path: "/blog/kakobuy-spreadsheet-adidas",
    element: <BlogPost />,
  },
  {
    path: "/blog/best-kakobuy-finds",
    element: <BlogPost />,
  },
  {
    path: "/blog/kakobuy-spreadsheet-jackets",
    element: <BlogPost />,
  },
  {
    path: "/blog/kakobuy-spreadsheet-accessories",
    element: <BlogPost />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;